/**
 * 論文用英文の統計表記。
 * p 値は先頭の 0 を省略しない（例: p < 0.001, p = 0.015）。
 * 小数桁は IEEE754 の誤差で 3.295 が 3.29 になるのを避けるため、固定精度の整数スケールで半分切り上げする。
 */

const INTERNAL_DECIMALS = 15;

/**
 * 論文用の固定小数桁（半分切り上げ）。例: 3.295, digits=2 → "3.30"
 */
export function formatManuscriptFixedDigits(value: number, digits: number): string {
  if (!Number.isFinite(value)) return '—';
  if (digits < 0) return String(value);

  const intVal = Math.round(value * 10 ** INTERNAL_DECIMALS);
  if (digits === 0) {
    const rounded = Math.round(intVal / 10 ** INTERNAL_DECIMALS);
    return String(rounded);
  }

  const scaleOut = 10 ** (INTERNAL_DECIMALS - digits);
  const halfUpInt = Math.round(intVal / scaleOut);
  const neg = halfUpInt < 0;
  const absU = Math.abs(halfUpInt);
  const intPart = Math.floor(absU / 10 ** digits);
  const frac = absU % 10 ** digits;
  const fracStr = String(frac).padStart(digits, '0');
  return `${neg ? '-' : ''}${intPart}.${fracStr}`;
}

export function formatManuscriptPValue(value: number): string {
  if (!Number.isFinite(value)) return 'p = —';
  if (value < 0) return 'p = —';
  if (value > 1) return 'p > 1';
  if (value < 0.001) return 'p < 0.001';
  /* 0.01 ≤ p < 0.05 は 3 桁（0.015 等）；p ≥ 0.05 は 2 桁 */
  if (value < 0.05) return `p = ${formatManuscriptFixedDigits(value, 3)}`;
  return `p = ${formatManuscriptFixedDigits(value, 2)}`;
}
